/* eslint-disable react/require-default-props */
import React from 'react';
import { Questions } from '../../messaging/seeker/candidate/questions/Questions';
import useCandidate from '../../../app/components/useCandidate';

// eslint-disable-next-line import/no-default-export, @typescript-eslint/explicit-module-boundary-types
export default function ProfileQuestions({
  handleActionAfterEngage,
  candidateId,
  positionId,
}: {
  handleActionAfterEngage?: (seekerId: string) => void;
  candidateId?: string;
  positionId?: string;
}) {
  const selectedCandidate = useCandidate(candidateId);
  return (
    <Questions
      handleActionAfterEngage={handleActionAfterEngage}
      candidateFromTopCandidate={selectedCandidate?.candidate}
      positionId={positionId}
    />
  );
}
